import {
  Center,
  Grid,
  GridItem,
  Link,
  Spinner,
  VStack,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useContainer } from "./useContainer";
import { ContestListItem } from "@/components/contest/contestListItem";
import {
  BOTTOM_TABS_HEIGHT,
  BottomTabs,
} from "@/components/common/bottomTabs/bottomTabs";
import { StoryTypeModal } from "@/components/common/storyTypeModal";
import { useHandleStoryTypeModal } from "@/hooks/useHandleStoryTypeModal";
import { useAppParameters } from "@/hooks/useAppParameters";
import { AppHeader } from "@/components/common/header/appHeader";
import { NavigationHeaderContainer } from "@/containers/navigationHeaderContainer";
import { Metadata } from "@/components/common/metadata";

export const ContestListContainer = () => {
  const navigate = useNavigate();
  const { items, showLoading, hasNext, infiniteRef } = useContainer();
  const { storyTypeModalDisclosure, toWriteChatNovel, toWriteNovel } =
    useHandleStoryTypeModal();
  const { isApp } = useAppParameters();
  return (
    <>
      <Metadata title="コンテスト" />
      <VStack
        minH="100svh"
        w="100%"
        h="100%"
        bg="backgroundPrimary"
        gap="0"
        pb="env(safe-area-inset-bottom)"
      >
        {isApp ? (
          <AppHeader title="コンテスト" noBackButton moreButton={false} />
        ) : (
          <NavigationHeaderContainer
            onClickWriteStory={storyTypeModalDisclosure.onOpen}
          />
        )}
        <Center
          flex={1}
          w="100%"
          h="100%"
          overflowY="scroll"
          scrollbarWidth="none"
          pb={BOTTOM_TABS_HEIGHT}
        >
          {showLoading ? <Spinner size="lg" /> : null}
          {items.length > 0 ? (
            <VStack
              w="100%"
              h="100%"
              maxW="1100px"
              overflowY="scroll"
              scrollbarWidth="none"
              p="4"
              gap="4"
            >
              <VStack w="100%" gap="4">
                <Grid
                  templateColumns={{
                    base: "1fr",
                    md: "repeat(2, 1fr)",
                    lg: "repeat(3, 1fr)",
                  }}
                  gap={4}
                  w="100%"
                >
                  {/* 最初の3つのアイテム */}
                  {items.slice(0, 3).map((item) => (
                    <GridItem key={`item-${item.id}`}>
                      <Link
                        href={
                          isApp
                            ? `/contests/${item.id}?isApp=1&isWebView=1`
                            : `/contests/${item.id}`
                        }
                        w="full"
                        WebkitTapHighlightColor="transparent"
                      >
                        <ContestListItem item={item} size="lg" />
                      </Link>
                    </GridItem>
                  ))}
                </Grid>

                {/* 4番目以降のアイテム */}
                <Grid
                  templateColumns={{
                    base: "repeat(2, 1fr)",
                    md: "repeat(3, 1fr)",
                    lg: "repeat(4, 1fr)",
                  }}
                  gap={4}
                  w="100%"
                >
                  {items.slice(3).map((item) => (
                    <GridItem key={`item-${item.id}`}>
                      <Link
                        href={
                          isApp
                            ? `/contests/${item.id}?isApp=1&isWebView=1`
                            : `/contests/${item.id}`
                        }
                        w="full"
                        WebkitTapHighlightColor="transparent"
                      >
                        <ContestListItem item={item} size="md" />
                      </Link>
                    </GridItem>
                  ))}
                </Grid>
              </VStack>

              {hasNext ? <Spinner size="lg" ref={infiniteRef} /> : null}
            </VStack>
          ) : null}
        </Center>

        <BottomTabs
          selectedTab="contest"
          flexShrink={0}
          display={{
            base: "flex",
            lg: "none",
          }}
          onPressTab={(tab) => {
            switch (tab) {
              case "home":
                navigate("/?notransition=1");
                break;
              case "contest":
                // nop
                break;
              case "write":
                storyTypeModalDisclosure.onOpen();
                break;
              default:
                // nop
                break;
            }
          }}
          position="fixed"
          bottom="env(safe-area-inset-bottom)"
        />
      </VStack>
      <StoryTypeModal
        open={storyTypeModalDisclosure.open}
        onClose={storyTypeModalDisclosure.onClose}
        onChatClicked={toWriteChatNovel}
        onNovelClicked={toWriteNovel}
      />
    </>
  );
};
